import OurProjectsLogo from './OurProjectsLogo';
export default OurProjectsLogo;
